<template>
  <div class="contenedor">
     <div class="row">
      <LoadingSpinner v-if="loading"/>
     </div>
     <div class="row table-responsive"  v-if="!loading">
      <div class="row mt-1">
        <div class="col">
        {{modeldomain}}
          <button @click="deleteDomains()"
          :key="keybuttondelete"
          v-if="modeldomain.selectedIds" :disabled="modeldomain.selectedIds.length == 0" class="btn btn-sm btn-danger">Delete</button>

          Domains without email accounts
          <div class="col-12 scrollable">
            <Table
              v-if="workspace_domain.length > 0"
              :key="32234"
              :headers="headersDomain"
              :cols="colsDomain"
              :data="workspace_domain"
              :checkbox="true"
              :notselect="false"
              :model="modeldomain"
              @toggleItem="$forceUpdate();keybuttondelete++"
              @openUser="openUser"
              @openClient="openClient"
            >
            </Table>
          </div>
        </div>
      </div>
  </div>
</div>
</template>
<script>
import Table from "@/components/Common/Table.vue";
import Modal from "@/components/Common/Modal.vue";
import AddEmailWorkspace from "@/components/Workspace/AddEmailWorkspace.vue";
import AddDomainWorkspace from "@/components/Workspace/AddDomainWorkspace.vue";

import {
  adminService,
  monitorService,
  campaignsService,
  workspaceService,
  usersService,
  opportunitiesService
} from "@/_services";
import VueFormGenerator from "vue-form-generator";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import Pagination from "@/components/Common/Pagination.vue";

export default {
  data() {
    return {
      keybuttondelete:323432,
      modeldomain:{},
      colsDomain:[],
      headersDomain:[],
      loading:false
    }
  },
  components: {
    Table,
    "vue-form-generator": VueFormGenerator.component,
    LoadingSpinner,
    Pagination,
    Modal,
    AddEmailWorkspace,
    AddDomainWorkspace
  },


  computed: {
    user() {
      return this.$store.state.authentication.user;
    },
  },

  created() {

    if(this.complete){
      this.headersDomain = [
        {
          label: "Domain",
          size: "130",
          class: "overflowhide",
        },
        {
          label: "Client name",
          size: "130",
          class: "overflowhide",
        },
        {
          label: "Client Status",
          size: "130",
          class: "overflowhide",
        },
        {
          label: "Sale",
          size: "130",
          class: "overflowhide",
        },
        {
          label: "Sale status",
          size: "130",
          class: "overflowhide",
        },
        {
          label: "Workspace",
          size: "130",
          class: "overflowhide",
        },
        {
          label: "Created",
          size: "130",
          class: "overflowhide",
        },
        {
          label: "Renew date",
          size: "130",
          class: "overflowhide",
        },
        {
          label: "Type",
          size: "130",
          class: "overflowhide",
        }
        ]

      this.colsDomain = [
        [
          {
            value: "domain",
          },
        ],
        [
          {
            value: "company_name",
          },
        ],
        [
          {
            value: "client_status",
          },
        ],
        [
          {
            value: "sale_name",
          },
        ],
        [
          {
            value: "sale_status",
          },
        ],
        [
          {
            value: "workspace",
          },
        ],
        [
          {
            value: "created",
          },
        ],
        [
          {
            value: "renew_date",
          },
        ],
        [
          {
            value: "cat",
          },
        ]
      ];

    } else {
      this.headersDomain = [
        {
          label: "Domain",
          size: "130",
          class: "overflowhide",
        },
        {
          label: "Created",
          size: "130",
          class: "overflowhide",
        },
        ]

      this.colsDomain = [
        [
          {
            value: "domain",
          },
        ],
        [
          {
            value: "created",
          },
        ]
      ];

    }
  },
  props:{
    client_id:false,
    workspace_domain: {
      type: Array,
      default: []
    },
    complete: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    deleteDomains(){
      this.loading=true
      workspaceService.deleteDomains(this.modeldomain.selectedIds).then((result) => {
        this.loading=false
        this.$emit("refresh")

      });
    },
    openClient(client_id) {
      let url = "/clients/" + client_id;
      window.open(url, "_blank");
    },
    openUser(user_id) {
      let url = "/users/" + user_id;
      window.open(url, "_blank");
    },
  }
};
</script>

